import React from "react";
import "./ApprovedTagChips.css";

const ApprovedTagChips = ({
  tags = [],
  selectedSlugs = [],
  onTagClick,
  maxSelected,
  className = "",
  size = "default",
  interactive = true,
}) => {
  const selectedSet = new Set(selectedSlugs);
  const maxReached =
    Number.isFinite(maxSelected) && selectedSet.size >= maxSelected;

  if (!Array.isArray(tags) || tags.length === 0) {
    return null;
  }

  return (
    <div
      className={`approved-tags approved-tags-${size} ${className}`.trim()}
    >
      {tags.map((tag) => {
        const isSelected = interactive && selectedSet.has(tag.slug);
        const isDisabled = Boolean(maxReached && !isSelected);
        const chipClassName = `approved-tag-chip ${
          isSelected ? "approved-tag-chip-selected" : ""
        } ${interactive ? "" : "approved-tag-chip-static"}`.trim();

        if (!interactive) {
          return (
            <span key={tag.slug} className={chipClassName}>
              {tag.label}
            </span>
          );
        }

        return (
          <button
            key={tag.slug}
            type="button"
            className={chipClassName}
            onClick={() => onTagClick?.(tag.slug)}
            aria-pressed={isSelected}
            disabled={isDisabled}
          >
            {tag.label}
          </button>
        );
      })}
    </div>
  );
};

export default ApprovedTagChips;
